let configuredApiUrl: string | null = null;

export const setApiUrl = (url: string): void => {
  configuredApiUrl = url;
};

export const getApiUrl = (): string | null => {
  return configuredApiUrl;
};

export const getBackendUrl = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname.includes('.e2b.app')) {
      const match = hostname.match(/(\d+)-(.+)\.e2b\.app/);

      if (match) {
        const [, , instanceId] = match;
        return `https://5000-${instanceId}.e2b.app`;
      }
    }
  }
  if (configuredApiUrl) {
    return configuredApiUrl;
  }
  return 'http://localhost:5000';
};
